<template>
  <div class="footer-links">
    <!------------------< DropsКлуб >-------------------->
    <div class="footer-links__clmn footer-links__clmn--drops">
      <p class="footer-links__ttl">Кэпитал</p>
      <router-link class="footer-links__lnk" :to="{name: PATHS_NAME.MAIN}">
        <AlphaIcon class="footer-links__icon" />Инфошум и Альфа
      </router-link>
      <router-link class="footer-links__lnk" :to="{name: PATHS_NAME.CALENDAR}">
        <CalendarIcon class="footer-links__icon" /> Календарь
      </router-link>
      <router-link class="footer-links__lnk" :to="{name: PATHS_NAME.FORECASTERS}">
        <ForecasterIcon class="footer-links__icon" />Форкастеры
      </router-link>
      <router-link class="footer-links__lnk" :to="{name: PATHS_NAME.SIGNALS}">
        <SignalIcon class="footer-links__icon" />Сигналы
      </router-link>
      <router-link class="footer-links__lnk" :to="{name: PATHS_NAME.SCANNER}">
        <ScreanerIcon class="footer-links__icon" />Скриннер
      </router-link>
      <router-link class="footer-links__lnk" :to="{name: PATHS_NAME.KNOWLEDGE_BASE}">
        <KnowledgeBase class="footer-links__icon" /> База знаний
      </router-link>
    </div>
    <!-------------------< Общение >--------------------->
    <div class="footer-links__clmn footer-links__clmn--community">
      <p class="footer-links__ttl">Чаты и ресурсы</p>
      <a class="footer-links__lnk" href="https://t.me/drops_daily" target="_blank" rel="nofollow">Кэпитал News</a>
      <a 
        class="footer-links__lnk" 
        :class="{'footer-links__lnk--disabled' : !isPaid}" 
        href="https://t.me/+CbJGANCaNcJjNGIy" 
        target="_blank" 
        rel="nofollow"
      >
        PoN MEME <TagLock v-if="!isPaid"/>
      </a>
      <a 
        class="footer-links__lnk" 
        :class="{'footer-links__lnk--disabled' : !isPaid}" 
        href="https://t.me/+6mrvhmDBdG5jMjc6" 
        target="_blank" 
        rel="nofollow"
      >
        Кэпитал Work <TagLock v-if="!isPaid"/>
      </a>
      <a 
        class="footer-links__lnk" 
        :class="{'footer-links__lnk--disabled' : !isPaid}" 
        href="https://t.me/+LsimjfsTOgg5YzFi" 
        target="_blank" 
        rel="nofollow">
        PoN Алертс <TagLock v-if="!isPaid"/>
      </a>
      <a 
        class="footer-links__lnk" 
        :class="{'footer-links__lnk--disabled' : !isPonHolder}" 
        href="https://telegram.me/collablandbot?start=VFBDI1RFTCNDT01NIy0xMDAxODkyMjYzODQ1" 
        target="_blank" 
        rel="nofollow"
      >
        PoN Holders <TagLock v-if="!isPonHolder"/>
      </a>
    </div>
    <!------------------< Экосистемам >------------------>
    <div class="footer-links__clmn footer-links__clmn--ecosystems">
      <p class="footer-links__ttl">Экосистема</p>
      <a class="footer-links__lnk" href="https://dropstab.com" target="_blank">DropsTab</a>
      <a class="footer-links__lnk" href="https://icodrops.com/" target="_blank">ICO Drops</a>
      <a class="footer-links__lnk" href="https://t.me/joinchat/FoisO1Ge70JnvvyaFMdBsQ" target="_blank">Cryptonarnia Chat (RU)</a>
    </div>
    <!------------------< Обратная связь >------------------>
    <div class="footer-links__clmn footer-links__clmn--feedback">
      <p class="footer-links__ttl">Разное</p>
      <router-link class="footer-links__lnk" :to="{name: PATHS_NAME.FEEDBACK}">Обратная связь</router-link>
      <router-link class="footer-links__lnk" :to="{name: PATHS_NAME.KNOWLEDGE_BASE, params: { slug: 'privacy' }}">Политика конфиденциальности</router-link>
    </div>
    <FooterText class="footer-links__txt-section" v-if="screenWidth >= 1150"/>
  </div>
</template>

<script setup>
  import { computed } from "vue";
  import { PATHS_NAME } from "@shared/routers/consts/pathsName";
  import { useStore } from "vuex";
  import { useScreenSize } from "@shared/composables/screenWidth/useScreenSize";
  //-----------------------------------
  const { screenWidth } = useScreenSize();
  //-----------------------------------
  import AlphaIcon from "@shared/UI/SVG/navigation/AlphaIcon.vue";
  import CalendarIcon from "@shared/UI/SVG/navigation/CalendarIcon.vue";
  import ForecasterIcon from "@shared/UI/SVG/navigation/ForecasterIcon.vue";
  import SignalIcon from "@shared/UI/SVG/navigation/SignalIcon.vue";
  import ScreanerIcon from "@shared/UI/SVG/navigation/ScreanerIcon.vue";
  import TagLock from "@shared/UI/Tags/TagLock/TagLock.vue";
  import KnowledgeBase from "@shared/UI/SVG/navigation/KnowledgeBase.vue";
  import FooterText from "../FooterText/FooterText.vue";
  //-----------------------------------
  const store = useStore();
  //-----------------------------------
  //Имеет ли пользователь доступ к платному контенту?
  const isPaid = computed(() => store.getters['UserSystem/hasPaidAccess']);
  //Имеет ли пользователь PoN
  const isPonHolder = computed(() => store.getters['UserSystem/hasPon']);
</script>

<style scoped lang="scss">
  @import './styles';
</style>